export { resolveNested } from "./callable.lib.ts";
